import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <path d="M14.6 7.2 4.6.2C3.9-.3 3 .2 3 1V15C3 15.8 3.9 16.3 4.6 15.8L14.6 8.8C15.1 8.4 15.1 7.6 14.6 7.2Z" />,
  'Play',
);
